module.exports = __webpack_public_path__ + "img/lookbook_9_right.f8e712a6.png";